import { createRoot } from 'react-dom/client';
import { VehicleSelector } from './components/VehicleSelector.js';
import { ProductFitmentChecker } from './components/ProductFitmentChecker.js';
import { SearchBar } from './components/SearchBar.js';
import { GlobalVehicleModal } from './components/GlobalVehicleModal.js';
import { ProductType, useVehicleModalStore } from './state/modalStore.js';
import { addSavedVehicle } from './vehicleHistory.js';
import { SelectedVehicle } from './components/VehicleSelectionForm.js';

export function initializeVehicleSelectors() {
  document.querySelectorAll('.gbrakes-vehicle-selector-root').forEach(el => {
    const invalidVehicle = el.getAttribute('data-invalid-vehicle');
    const showHistory = el.hasAttribute('data-show-history');
    const ptype = el.getAttribute('data-ptype') as ProductType;
    createRoot(el).render(
      <VehicleSelector 
        invalidVehicle={invalidVehicle ? JSON.parse(invalidVehicle) : null} 
        showHistory={showHistory} 
        ptype={ptype} 
        />
    );
  });
}

export function initializeFitmentCheckers() {
  document.querySelectorAll('.gbrakes-product-fitment-checker-root').forEach(el => {
    const sku = (el as HTMLElement).dataset.sku;
    const ptype = el.getAttribute('data-ptype') as ProductType;
    if (sku) {
      createRoot(el).render(<ProductFitmentChecker sku={sku} ptype={ptype} />);
    }
  });
}

export function initializeSearchBars() {
  document.querySelectorAll('.gbrakes-search-bar-root').forEach(el => {
    const ptype = (el as HTMLElement).dataset.ptype;
    createRoot(el).render(<SearchBar ptype={ptype || ""} />);
  });
}

export function initializeGlobalModal() {
  let modalRoot = document.getElementById('gbrakes-global-modal-root');
  if (!modalRoot) {
    modalRoot = document.createElement('div');
    modalRoot.id = 'gbrakes-global-modal-root';
    document.body.appendChild(modalRoot);
  }
  createRoot(modalRoot).render(<GlobalVehicleModal />);
}

export function initializeModalButtons() {
  const openModal = useVehicleModalStore.getState().openModal;

  const handleVehicleSelect = (vehicle: SelectedVehicle) => {
    const ptype = useVehicleModalStore.getState().ptype;
    const uroot = ptype === "clearance" ? "/clearance-fitment" : "/fitment"
    addSavedVehicle({ makeName: vehicle.makeName, modelName: vehicle.modelName, year: vehicle.year, makeSlug: vehicle.makeSlug, modelSlug: vehicle.modelSlug });
    window.location.href = `${uroot}/${vehicle.makeSlug}/${vehicle.modelSlug}/${vehicle.year}/`;
  };

  document.querySelectorAll<HTMLElement>('.gbrakes-open-modal-button').forEach(button => {
    const ptype: ProductType = (button.dataset.ptype || "") as ProductType;
    button.addEventListener('click', () => openModal(handleVehicleSelect, undefined, ptype));
  });
}